import React, { useState, useRef, useMemo, useEffect } from "react";
import {
  Button,
  Table,
  Form,
  Row,
  Col,
  Modal,
  Dropdown
} from "react-bootstrap";
import DatePicker, { registerLocale } from "react-datepicker";
import enGB from "date-fns/locale/en-GB";
import { ReactComponent as BookOn } from "../../images/events/book-on.svg";
import { ReactComponent as BookOff } from "../../images/events/book-off.svg";
import { ReactComponent as ViewProfile } from "../../images/events/view-profile.svg";
import { ReactComponent as ViewOccur } from "../../images/events/view-occurrence.svg";
import { ReactComponent as LogOccur } from "../../images/events/log-occurrence.svg";
import { apiUrl } from "../../config.js";
import { useCookies } from "react-cookie";
import {
  BsChevronExpand,
  BsChevronUp,
  BsChevronDown,
  BsXCircle
} from "react-icons/bs";
import SearchableDropdown from "../EventControl-Component/SearchableDropdown";
import { BsLaptop } from "react-icons/bs";
import { VscGraph } from "react-icons/vsc";
import { RiUserSearchFill } from "react-icons/ri";
import LoadingSpinner from "../Loading-Component/Loading";
import { BsFillFunnelFill } from "react-icons/bs";
import LocationSearchableDropdown from "../EventControl-Component/LocationSearchableDropdown";
import EventControlPersonRow from "./EventControlPersonRow";
function EventControlTable() {
  const [cookies, setCookie] = useCookies(["jwt", "coid"]);
  const jwt = cookies["jwt"];
  const [loading, setLoading] = useState(false);
  const [StaffData, setStaffData] = useState([]);
  const [initilaStaffData, setinitialStaffData] = useState([]);
  const [filterData1, setFilterData1] = useState([]);
  const [filterData2, setFilterData2] = useState([]);
  const [isAllocated, setIsAllocated] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedRotaShiftIds, setSelectedRotaShiftIds] = useState([]);
  const eventRequestObject = {
    Search: null, // These values should be obtained from your component's state or props
    StartTime: null, // Ensure date is in ISO format if not null
    Role: null, // Convert to Number if not null, assuming role is a numeric ID
    Location: null,
    EventVenueId: null,
    Engagementmethod: null,
    Offset: null // Convert to Number, assuming non-null
  };
  const [searchSelectedValue, setSearchSelectedValue] = useState("");
  const [filterValues, setFilterValues] = useState(eventRequestObject);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const tableRef = useRef(null);
  const [conflictStaff, setConflictStaff] = useState([]); // full staff objects
  const [showConflictModal, setShowConflictModal] = useState(false);
  const [conflictRemoveIds, setConflictRemoveIds] = useState([]); // rotaShiftIds to remove
  const [conflictAction, setConflictAction] = useState(null); // 'on' | 'off'
  const [conflictOnOffStatus, setConflictOnOffStatus] = useState(null);
  const [sites, setSites] = useState([]); // from result set 1
  const [siteEvents, setSiteEvents] = useState([]); // from result set 2
  const [selectedSiteId, setSelectedSiteId] = useState("");
  const [siteSearchTerm, setSiteSearchTerm] = useState("");
  const [selectedClient, setSelectedClient] = useState("");
  const [clientSearchTerm, setClientSearchTerm] = useState("");
  const [selectedEvent, setselectedEvent] = useState("");
  const [eventSearchTerm, setEventSearchTerm] = useState("");
  const [disableApply, setdisableApply] = useState(true);
  registerLocale("en-GB", enGB);
  const dateRangeRef = useRef({
    from: null,
    to: null
  });
  const [selectedDay, setSelectedDay] = useState(() => new Date());

  const displayData = useMemo(() => {
    return isAllocated
      ? StaffData.filter((x) => x.firstName || x.lastName) // allocated
      : StaffData.filter((x) => !x.firstName && !x.lastName); // unallocated
  }, [StaffData, isAllocated]);

  const totalItems = displayData.length;

  const getShowingText = (totalItems) => {
    if (totalItems === 0) return "Showing 0–0 of 0";
    return `Showing 1–${totalItems} of ${totalItems}`;
  };
  let sortedStaff = [...displayData];
  if (sortConfig.key) {
    sortedStaff.sort((a, b) => {
      let aVal = a[sortConfig.key];
      let bVal = b[sortConfig.key];

      if (aVal == null) aVal = "";
      if (bVal == null) bVal = "";

      if (sortConfig.key === "startTime" || sortConfig.key === "finishTime") {
        aVal = new Date(aVal);
        bVal = new Date(bVal);
      }

      if (typeof aVal === "string" && typeof bVal === "string") {
        const cmp = aVal.localeCompare(bVal);
        return sortConfig.direction === "asc" ? cmp : -cmp;
      }

      if (aVal < bVal) return sortConfig.direction === "asc" ? -1 : 1;
      if (aVal > bVal) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
  }
  /*  const currentRows = sortedStaff.slice(indexOfFirstRow, indexOfLastRow);*/

  const requestSort = (key) => {
    setSortConfig((prev) => {
      if (prev.key === key) {
        // toggle direction
        const newDirection = prev.direction === "asc" ? "desc" : "asc";
        return { key, direction: newDirection };
      }
      // first time sorting this column → ascending
      return { key, direction: "asc" };
    });
  };

  const endOfDayMs = (ms) => {
    const x = new Date(ms);
    x.setHours(23, 59, 59, 999);
    return x.getTime();
  };

  const getCurrentRange = () => {
    const { from, to } = dateRangeRef.current;

    return {
      Fromdate: from,
      Todate: to
    };
  };

  const abortRef = useRef(null);

  const fetchFiltersWithCurrentRange = async () => {
    if (abortRef.current) abortRef.current.abort();
    const { Fromdate, Todate } = getCurrentRange();
    const controller = new AbortController();
    abortRef.current = controller;

    const fromIso = new Date(Fromdate).toISOString();
    const toIso = new Date(endOfDayMs(Todate)).toISOString();

    setLoading(true);

    try {
      const response = await fetch(
        `${apiUrl}/Events/PopulateVenueFilters?RangeFrom=${encodeURIComponent(
          fromIso
        )}&RangeTo=${encodeURIComponent(toIso)}`,
        {
          method: "GET",
          headers: { Authorization: `Bearer ${jwt}` },
          signal: controller.signal
        }
      );

      const res = await response.json();

      if (res.message) {
        console.warn(res.message);
        setSites([]);
        setSiteEvents([]);
        setStaffData([]);
      } else {
        setSites(res.sites || []);
        setSiteEvents(res.siteEvents || []);
        setStaffData([]);
        setinitialStaffData([]);
        setSelectedClient("");
        setSelectedSiteId("");
        setselectedEvent("");
      }
    } catch (err) {
      if (err.name !== "AbortError") console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const setDayAndFetch = (value) => {
    const day = value ? new Date(value) : new Date();

    const from = new Date(day);
    from.setHours(0, 0, 0, 0);

    const to = new Date(day);
    to.setHours(23, 59, 59, 999);

    dateRangeRef.current = { from, to };
    setSelectedDay(day);
    fetchFiltersWithCurrentRange();
  };

  useEffect(() => {
    setDayAndFetch(new Date());
  }, []);

  const siteOptions = useMemo(() => {
    if (!sites || sites.length === 0) return [];

    let filteredSites = sites;

    if (selectedClient) {
      filteredSites = filteredSites.filter(
        (s) => s.clientName === selectedClient
      );
      // Remove it if needed.
    }

    return filteredSites.map((s) => ({
      value: String(s.siteId),
      label: s.siteName,
      clientName: s.clientName
    }));
  }, [sites, selectedClient]);

  // Bootstrap tooltiip
  const Tooltip = ({ children }) => {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    // close when clicking outside
    useEffect(() => {
      const handleClickOutside = (e) => {
        if (ref.current && !ref.current.contains(e.target)) {
          setOpen(false);
        }
      };

      document.addEventListener("mousedown", handleClickOutside);
      return () =>
        document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
      <span ref={ref} className="position-relative d-inline-block">
        <button
          type="button"
          onClick={() => setOpen(!open)}
          className="btn btn-link p-0 ms-1 d-flex ms-2 align-items-center"
          aria-label="Help"
        >
          <span
            className="d-inline-flex align-items-center justify-content-center border rounded-circle"
            style={{ width: 18, height: 18, fontSize: 12, color: "#fff" }}
          >
            ?
          </span>
        </button>

        {open && (
          <div
            className="position-absolute bg-white border rounded shadow p-2 mt-2 table-tooltip"
            style={{ minWidth: 200, zIndex: 1000, right: 0 }}
          >
            {children}
          </div>
        )}
      </span>
    );
  };

  // Filtered sites for searchable dropdown
  const filteredSites = useMemo(() => {
    if (!siteOptions || siteOptions.length === 0) return [];

    if (!siteSearchTerm) return siteOptions;

    const term = siteSearchTerm.toLowerCase();

    return siteOptions.filter((s) => s.label.toLowerCase().includes(term));
  }, [siteOptions, siteSearchTerm]);

  const clientOptions = useMemo(() => {
    if (!sites || sites.length === 0) return [];

    const set = new Set();
    sites.forEach((s) => {
      if (s.clientName) {
        set.add(s.clientName);
      }
    });

    return Array.from(set).map((client) => ({
      value: client,
      label: client
    }));
  }, [sites]);

  const filteredClients = useMemo(() => {
    if (!clientOptions || clientOptions.length === 0) return [];

    if (!clientSearchTerm) return clientOptions;

    const term = clientSearchTerm.toLowerCase();
    return clientOptions.filter((c) => c.label.toLowerCase().includes(term));
  }, [clientOptions, clientSearchTerm]);

  const eventOptions = useMemo(() => {
    if (!siteEvents || siteEvents.length === 0) return [];

    const set = new Set();

    siteEvents.forEach((se) => {
      // 1) If a site is selected, only take events for that site
      if (selectedSiteId && String(se.siteId) !== String(selectedSiteId)) {
        return;
      }

      // 2) If a client is selected, ensure event's site belongs to that client
      if (selectedClient) {
        const site = sites.find((s) => String(s.siteId) === String(se.siteId));
        if (!site || site.clientName !== selectedClient) {
          return;
        }
      }

      if (se.eventName) {
        set.add(se.eventName);
      }
    });

    return Array.from(set).map((event) => ({
      value: event,
      label: event
    }));
  }, [siteEvents, sites, selectedClient, selectedSiteId]);

  const filteredEvents = useMemo(() => {
    if (!eventOptions || eventOptions.length === 0) return [];

    if (!eventSearchTerm) return eventOptions;

    const term = eventSearchTerm.toLowerCase();
    return eventOptions.filter((e) => e.label.toLowerCase().includes(term));
  }, [eventOptions, eventSearchTerm]);

  // When client changes, reset site & event
  const handleClientChange = (value) => {
    setSelectedClient(value);
    setSelectedSiteId("");
    setdisableApply(false);
    // setselectedEvent(""); // if you have event state too
  };

  // When site changes, reset event
  const handleSiteChange = (value) => {
    setSelectedSiteId(value);
    setdisableApply(false);
    // setselectedEvent("");
  };

  const handleEventNameChanges = (value) => {
    setselectedEvent(value);
    setdisableApply(false);
  };

  const handleApplyFilters = () => {
    const { Fromdate, Todate } = getCurrentRange();
    const siteObj = selectedSiteId
      ? sites.find((s) => String(s.siteId) === String(selectedSiteId))
      : null;

    const payload = {
      clientName: selectedClient || null,
      siteId: selectedSiteId || null,
      siteName: siteObj?.siteName || null,
      eventName: selectedEvent || null,
      RangeFrom: Fromdate.toISOString(),
      RangeTo: Todate.toISOString(),
      AllocatedStatus: isAllocated
    };

    getShifts(payload);
  };

  const handleClearFilters = () => {
    setSelectedClient("");
    setSelectedSiteId("");
    setselectedEvent("");
    setdisableApply(true);
    setClientSearchTerm("");
    setSiteSearchTerm("");
    setEventSearchTerm("");
    setSearchTerm("");
  };

  // This is purley for search of name in the second filters
  const searchOptions = React.useMemo(() => {
    if (!initilaStaffData) return [];

    const names = initilaStaffData
      .map((p) => {
        const first = (p.firstName || "").trim();
        const last = (p.lastName || "").trim();
        const full = [first, last].filter(Boolean).join(" ");
        return full || null;
      })
      .filter(Boolean); // remove null/empty

    const uniqueNames = Array.from(new Set(names));

    return uniqueNames.map((name) => ({
      value: name,
      label: name
    }));
  }, [initilaStaffData]);

  const filteredSearchOptions = React.useMemo(() => {
    const term = (searchTerm || "").toLowerCase();
    if (!term) return searchOptions;
    return searchOptions.filter((o) => o.label.toLowerCase().includes(term));
  }, [searchTerm, searchOptions]);

  useEffect(() => {
    // Start from full initial staff list
    let filtered = initilaStaffData;

    // 1) ROLE filter
    if (filterValues.Role) {
      filtered = filtered.filter(
        (p) => (p.roleName || "") === filterValues.Role
      );
    }

    // 2) LOCATION filter
    if (filterValues.Location) {
      filtered = filtered.filter(
        (p) => (p.eventLocation || "") === filterValues.Location
      );
    }

    // 3) START TIME filter (compare full datetime)
    if (filterValues.StartTime) {
      const targetTime = new Date(filterValues.StartTime).getTime();

      filtered = filtered.filter((p) => {
        if (!p.startTime) return false;
        const rowTime = new Date(p.startTime).getTime();
        return rowTime === targetTime;
      });
    }

    if (filterValues.Engagementmethod) {
      filtered = filtered.filter(
        (p) => (p.engagementmethod || "") === filterValues.Engagementmethod
      );
    }

    // 4) TEXT SEARCH (SearchTerm) – same behaviour as before
    const term = (searchTerm || "").trim().toLowerCase();
    if (term && term.length > 0) {
      const lowerTerm = term.toLowerCase();

      filtered = filtered.filter((p) => {
        const first = (p.firstName || "").toLowerCase();
        const last = (p.lastName || "").toLowerCase();

        // "firstname lastname"
        const fullName = `${first} ${last}`.trim();

        return (
          first.includes(lowerTerm) ||
          last.includes(lowerTerm) ||
          fullName.includes(lowerTerm)
        );
      });
    }

    // 5) Push final result to UI
    updateStaffDataPreserveScroll(filtered);
  }, [
    searchTerm,
    filterValues.Role,
    filterValues.Location,
    filterValues.StartTime,
    filterValues.Engagementmethod,
    initilaStaffData
  ]);

  const extractTimeOnly = (dateTimeString) => {
    if (!dateTimeString) return "";

    const d = new Date(dateTimeString);
    const hh = String(d.getHours()).padStart(2, "0");
    const mm = String(d.getMinutes()).padStart(2, "0");

    return `${hh}:${mm}`; // returns "12:00"
  };

  const getShifts = async (data) => {
    let obj = data;

    setLoading(true);
    try {
      const response = await fetch(`${apiUrl}/Events/GetShifts`, {
        method: "POST",
        headers: {
          Authorization: `bearer ${jwt}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify(obj)
      });

      const res = await response.json();

      if (res.message != null) {
        window.alert(res.message);
        setLoading(false);
      } else if (res.data) {
        setStaffData(res.data);
        setinitialStaffData(res.data);
        setFilterValues(eventRequestObject); // basically clearning the second set of filters
        setSearchTerm("");
        setSearchSelectedValue("");
        setLoading(false);
        const uniqueLocations = Array.from(
          new Set(
            res.data
              .map((item) => item.eventLocation || "")
              .filter((x) => x !== "")
          )
        ).map((loc) => ({
          location: loc,
          starttime: null,
          startDateTime: null,
          engagementmethod: null
        }));

        const uniqueengagementmethod = Array.from(
          new Set(
            res.data
              .map((item) => item.engagementmethod || "")
              .filter((x) => x !== "")
          )
        ).map((engagement) => ({
          location: null,
          starttime: null,
          startDateTime: null,
          engagementmethod: engagement
        }));

        const startTimesMap = new Map();

        res.data.forEach((item) => {
          if (!item.startTime) return;

          const timeOnly = extractTimeOnly(item.startTime);

          if (!startTimesMap.has(timeOnly)) {
            startTimesMap.set(timeOnly, {
              location: null,
              starttime: timeOnly, // HH:mm (for display)
              startDateTime: new Date(item.startTime), // full datetime (for filtering)
              engagementmethod: null
            });
          }
        });

        const uniqueStartTimes = Array.from(startTimesMap.values());

        const filterData1 = [
          ...uniqueLocations,
          ...uniqueStartTimes,
          ...uniqueengagementmethod
        ];

        setFilterData1(filterData1);
        const roleMap = new Map();

        res.data.forEach((item) => {
          if (!item.roleName || !item.roleId) return;

          // Only add if this roleId hasn’t been added yet
          if (!roleMap.has(item.roleId)) {
            roleMap.set(item.roleId, {
              roleId: item.roleId,
              roleName: item.roleName
            });
          }
        });

        const uniqueRoles = Array.from(roleMap.values());

        setFilterData2(uniqueRoles);

        setdisableApply(true);
      } else {
        window.alert(
          "We've searched everywhere but we couldn't find any applicants that match your current filter criteria"
        );
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const handleBookOnOff = async (rotaShiftId, isbookon) => {
    if (rotaShiftId == null && selectedRotaShiftIds.length > 0) {
      let conflicts = [];
      let action = null;

      if (isbookon === 1) {
        // trying to Book On staff who are already booked on (and not booked off yet)
        conflicts = StaffData.filter(
          (s) =>
            selectedRotaShiftIds.includes(s.rotaShiftId) &&
            s.bookedOnDateTime != null &&
            !s.bookedOffDateTime
        );
        action = "on";
      } else if (isbookon === 0) {
        const notBookedOnConflicts = StaffData.filter(
          (s) =>
            selectedRotaShiftIds.includes(s.rotaShiftId) &&
            (s.bookedOnDateTime == null || s.bookedOnDateTime === "")
        );

        if (notBookedOnConflicts.length > 0) {
          conflicts = notBookedOnConflicts;
          action = "notOn";
        } else {
          conflicts = StaffData.filter(
            (s) =>
              selectedRotaShiftIds.includes(s.rotaShiftId) &&
              s.bookedOffDateTime != null
          );
          action = "off";
        }
      }

      if (conflicts.length > 0) {
        setConflictStaff(conflicts);
        setConflictRemoveIds([]);
        setConflictAction(action); // 'on' | 'off'
        setConflictOnOffStatus(isbookon); // 1 or 0
        setShowConflictModal(true);
        return;
      }
    }

    const idsToSend =
      selectedRotaShiftIds.length > 0 && rotaShiftId == null
        ? selectedRotaShiftIds.join(",")
        : rotaShiftId.toString();

    try {
      const response = await fetch(`${apiUrl}/Events/UpdateLocationBookonOff`, {
        method: "POST",
        headers: {
          Authorization: `bearer ${jwt}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ rotaShiftIds: idsToSend, onOffStatus: isbookon })
      });

      const updatedShift = await response.json();
      const idsToUpdate =
        selectedRotaShiftIds.length > 0 && rotaShiftId == null
          ? selectedRotaShiftIds.map((id) => id.toString())
          : [rotaShiftId.toString()];

      const idsToUpdateSet = new Set(idsToUpdate);

      const now = new Date();
      const formattedNow = now.toISOString().replace("Z", "").slice(0, 23);
      const finalNow = formattedNow.slice(0, -1);

      updateStaffDataPreserveScroll((prev) =>
        prev.map((data) =>
          idsToUpdateSet.has(data.rotaShiftId.toString())
            ? {
                ...data,
                ...(isbookon === 1
                  ? { bookedOnDateTime: finalNow }
                  : { bookedOffDateTime: finalNow })
              }
            : data
        )
      );
    } catch (error) {
      console.error(error);
    }
  };

  // toggle one conflict ID in the "to remove" list
  const toggleConflictRemove = (rotaShiftId) => {
    setConflictRemoveIds((prev) =>
      prev.includes(rotaShiftId)
        ? prev.filter((id) => id !== rotaShiftId)
        : [...prev, rotaShiftId]
    );
  };

  // select all conflicts for removal
  const selectAllConflictsForRemoval = () => {
    setConflictRemoveIds(conflictStaff.map((s) => s.rotaShiftId));
  };

  // clear all (user can re-select manually)
  const clearAllConflictsForRemoval = () => {
    setConflictRemoveIds([]);
  };

  // remove chosen conflicts from selection and continue with bulk Book On/Off
  const handleResolveConflictsAndContinue = async () => {
    const idsToRemove = conflictRemoveIds;

    // remove those from original selection
    const cleanedSelection = selectedRotaShiftIds.filter(
      (id) => !idsToRemove.includes(id)
    );

    setSelectedRotaShiftIds(cleanedSelection);
    setShowConflictModal(false);

    if (cleanedSelection.length === 0) {
      // nothing left to update
      return;
    }

    const idsToSend = cleanedSelection.join(",");

    try {
      const response = await fetch(`${apiUrl}/Events/UpdateLocationBookonOff`, {
        method: "POST",
        headers: {
          Authorization: `bearer ${jwt}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          rotaShiftIds: idsToSend,
          onOffStatus: conflictOnOffStatus // 1 (on) or 0 (off)
        })
      });

      const updatedShift = await response.json();
      const now = new Date();
      const formattedNow = now.toISOString().replace("Z", "").slice(0, 23);
      const finalNow = formattedNow.slice(0, -1);

      updateStaffDataPreserveScroll((prev) =>
        prev.map((data) => {
          if (!cleanedSelection.includes(data.rotaShiftId)) return data;

          if (conflictOnOffStatus === 1) {
            return {
              ...data,
              eventLocation: updatedShift.data.eventLocation,
              bookedOnDateTime: finalNow
            };
          } else {
            return {
              ...data,
              eventLocation: updatedShift.data.eventLocation,
              bookedOffDateTime: finalNow
            };
          }
        })
      );
    } catch (error) {
      console.error(error);
    }
  };

  const updateSelectedRotaShiftIdsPreserveScroll = (updater) => {
    const container = tableRef.current;
    const previousScrollTop = container ? container.scrollTop : 0;
    const previousWindowScrollY = window.scrollY;

    setSelectedRotaShiftIds((prev) => {
      const next = typeof updater === "function" ? updater(prev) : updater;

      // Restore scroll after render
      requestAnimationFrame(() => {
        if (container) {
          container.scrollTop = previousScrollTop;
        }
        window.scrollTo({
          top: previousWindowScrollY,
          behavior: "auto"
        });
      });

      return next;
    });
  };

  function handleCheckBoxChanges(rotashiftid, staffid, place) {
    updateSelectedRotaShiftIdsPreserveScroll((prev) => {
      if (prev.includes(rotashiftid)) {
        // Unselect if already selected
        return prev.filter((id) => id !== rotashiftid);
      } else {
        // Add the rotaShiftId
        return [...prev, rotashiftid];
      }
    });
  }

  const handleSelectAll = () => {
    if (selectedRotaShiftIds.length < StaffData.length) {
      updateSelectedRotaShiftIdsPreserveScroll(
        StaffData.map((person) => person.rotaShiftId)
      );
    } else {
      updateSelectedRotaShiftIdsPreserveScroll([]);
    }
  };

  // Handles the show and hide of the bulk edit
  const toggleHide = {
    display: selectedRotaShiftIds.length > 0 ? "flex" : "none"
  };

  async function fetchOccurrencesByRsid(rsid) {
    const res = await fetch(`${apiUrl}/Events/OccurancesByRsid/${rsid}`, {
      method: "GET",
      headers: {
        Authorization: `bearer ${jwt}`,
        "Content-Type": "application/json"
      }
    });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);

    const json = await res.json();
    const list = Array.isArray(json?.data) ? json.data : [];

    // Ensure consistent shape
    return list.map((it) => ({
      incidentId: it.incidentId,
      name: it.name ?? "",
      dateOfIncident: it.dateOfIncident ?? null
    }));
  }


  const handleProfileShiftUpdate = ({
    rotaShiftId,
    eventLocation,
    roleId,
    roleName
  }) => {
    updateStaffDataPreserveScroll((prev) =>
      prev.map((data) =>
        String(data.rotaShiftId) === String(rotaShiftId)
          ? {
              ...data,
              eventLocation,
              roleId,
              roleName
            }
          : data
      )
    );

    setinitialStaffData((prev) =>
      prev.map((data) =>
        String(data.rotaShiftId) === String(rotaShiftId)
          ? {
              ...data,
              eventLocation,
              roleId,
              roleName
            }
          : data
      )
    );

    addLocationToFilterData1(eventLocation);
  };

  // Legacy inline row components removed for parser safety.
  // Legacy modal profile flow removed for parser safety.

  const BulkEdit = ({ locationOptions, bookonoroff }) => {
    const [bulkLocation, setBulkLocation] = useState("");
    const handleBulkUpdateLocation = async () => {
      if (!bulkLocation) return; // No location selected

      const rotaShiftIdsString = selectedRotaShiftIds.join(",");
      const idsToUpdate = selectedRotaShiftIds;

      try {
        const response = await fetch(
          `${apiUrl}/Events/UpdateLocationBookonOff`,
          {
            method: "POST",
            headers: {
              Authorization: `bearer ${jwt}`,
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              rotaShiftIds: rotaShiftIdsString,
              location: bulkLocation
            })
          }
        );

        if (!response.ok) throw new Error("Failed to update locations");
        const updatedShift = await response.json();
        const nextLocation = updatedShift?.data?.eventLocation || bulkLocation;
        const idsToUpdateSet = new Set(idsToUpdate.map((id) => String(id)));
        updateStaffDataPreserveScroll((prev) =>
          prev.map((data) => {
            if (idsToUpdateSet.has(String(data.rotaShiftId))) {
              return {
                ...data,
                eventLocation: nextLocation
              };
            }
            return data;
          })
        );
        setinitialStaffData((prev) =>
          prev.map((data) => {
            if (idsToUpdateSet.has(String(data.rotaShiftId))) {
              return {
                ...data,
                eventLocation: nextLocation
              };
            }
            return data;
          })
        );
        addLocationToFilterData1(nextLocation);
      } catch (error) {
        console.error(error);
      }
    };
    return (
      <div
        className="align-items-center justify-content-between py-3 px-4 bulk-edit-block"
        style={toggleHide}
      >
        <div className="d-flex align-items-center no-bs-cell">
          <p className="text-light">
            No of rows selected : {selectedRotaShiftIds.length}
          </p>
        </div>
        <div className="d-flex align-items-center no-bs-cell">
          <Form.Group className="me-3" controlId="bulkLocationSelect">
            <LocationSearchableDropdown
              id="bulk-location-select"
              value={bulkLocation}
              onChange={(selectedValue) => setBulkLocation(selectedValue || "")}
              options={locationOptions}
              placeholder="Change location"
              dropUp={true}
            />
          </Form.Group>
          <Button
            title="Book On"
            className="rounded-button px-2 me-2"
            onClick={() => handleBookOnOff(null, 1)}
          >
            <BookOn />
          </Button>

          <Button
            title="Book Off"
            className="rounded-button px-2 me-2"
            onClick={() => handleBookOnOff(null, 0)}
          >
            <BookOff />
          </Button>
          <Button variant="primary" onClick={handleBulkUpdateLocation}>
            Apply
          </Button>
        </div>
      </div>
    );
  };
  const CustomInput = React.forwardRef(
    ({ value, onClick, className = "", style = {} }, ref) => (
      <input
        type="text"
        value={value || ""}
        onClick={onClick}
        ref={ref}
        readOnly
        className={`date-input ${className}`.trim()}
        style={{ width: "120px", ...style }}
      />
    )
  );

  const ApplyFilter = (field, value) => {
    setFilterValues((prev) => ({
      ...prev,
      [field]: value
    }));
  };

  const addLocationToFilterData1 = (locationValue) => {
    const normalized = (locationValue || "").trim();
    if (!normalized) return;

    setFilterData1((prev) => {
      const exists = prev.some(
        (item) =>
          item.location &&
          item.location.toLowerCase() === normalized.toLowerCase()
      );

      if (exists) return prev;

      return [
        ...prev,
        {
          location: normalized,
          starttime: null,
          startDateTime: null,
          engagementmethod: null
        }
      ];
    });
  };

  const updateStaffDataPreserveScroll = (updater) => {
    const container = tableRef.current;
    const previousScrollTop = container ? container.scrollTop : 0;
    const previousWindowScrollY = window.scrollY;

    setStaffData((prev) => {
      const next = typeof updater === "function" ? updater(prev) : updater;

      // Restore scroll *after* React paints the new rows
      requestAnimationFrame(() => {
        if (container) {
          container.scrollTop = previousScrollTop;
        }
        window.scrollTo({
          top: previousWindowScrollY,
          behavior: "auto"
        });
      });

      return next;
    });
  };

  const getSortIcon = (key) => {
    const isActive = sortConfig.key === key;
    const dir = sortConfig.direction;

    return (
      <span>
        {/* Not sorted */}
        {!isActive && <BsChevronExpand />}

        {/* Ascending */}
        {isActive && dir === "asc" && <BsChevronUp />}

        {/* Descending */}
        {isActive && dir === "desc" && <BsChevronDown />}
      </span>
    );
  };

  const [showFiltersPanel, setShowFiltersPanel] = useState(false);

  const toggleFiltersPanel = () => setShowFiltersPanel(true);
  const closeFiltersPanel = () => setShowFiltersPanel(false);

  return (
    <div className="event-table-page p-3 pt-5 mt-5">
      <LoadingSpinner loading={loading} />
      <div className="header mb-3">
        <div className="filters-toolbar">
          {/* LEFT: filters */}
          <div className="filters-left">
            {/* DATE */}
            <Form.Group className="filter-item-inline" controlId="dateSelect">
              <Form.Label className="filter-label">Date:</Form.Label>
              <DatePicker
                selected={selectedDay}
                onChange={(d) => setDayAndFetch(d)}
                dateFormat="dd/MM/yy"
                customInput={
                  <CustomInput className="form-control form-control-sm" />
                }
                isClearable={false}
                todayButton="Today"
                showPopperArrow={false}
              />
            </Form.Group>

            {initilaStaffData.length > 0 && (
              <>
                {/* SEARCH */}
                <Form.Group
                  className="filter-item-inline search-wide"
                  controlId="searchNameFilter"
                >
                  <Form.Label className="filter-label">Search:</Form.Label>

                  <div className="search-control-row">
                    <Dropdown
                      popperConfig={{ strategy: "fixed" }}
                      onSelect={(eventKey) => {
                        const value = eventKey;
                        setSearchSelectedValue(value);
                        setSearchTerm(value);
                      }}
                    >
                      <Dropdown.Toggle
                        id="dropdown-search"
                        className="filter-control dropdown-toggle-sm"
                        variant="outline-light"
                      >
                        <span className="truncate">
                          {searchSelectedValue || "Name"}
                        </span>
                      </Dropdown.Toggle>

                      <Dropdown.Menu className="dropdown-menu-sm">
                        <div
                          onClick={(e) => e.stopPropagation()}
                          className="px-2 py-2"
                        >
                          <div className="search-menu-row">
                            <input
                              type="text"
                              placeholder="Search..."
                              value={searchTerm}
                              className="form-control form-control-sm"
                              onChange={(e) => setSearchTerm(e.target.value)}
                            />

                            {(searchTerm || searchSelectedValue) && (
                              <BsXCircle
                                size={20}
                                role="button"
                                className="search-menu-clear me-2"
                                aria-label="Clear"
                                style={{ cursor: "pointer" }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  setSearchTerm("");
                                  setSearchSelectedValue("");
                                }}
                              />
                            )}
                          </div>
                        </div>

                        {filteredSearchOptions.map((opt) => (
                          <Dropdown.Item key={opt.value} eventKey={opt.value}>
                            {opt.label}
                          </Dropdown.Item>
                        ))}

                        {filteredSearchOptions.length === 0 && (
                          <div className="px-3 py-2 text-muted">No results</div>
                        )}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </Form.Group>

                {/* ROLE */}
                <Form.Group
                  className="filter-item-inline"
                  controlId="RoleSelect"
                >
                  <Form.Label className="filter-label">Role:</Form.Label>
                  <Form.Select
                    size="sm"
                    value={filterValues.Role || ""}
                    onChange={(e) =>
                      ApplyFilter("Role", e.target.value || null)
                    }
                  >
                    <option value="">Role</option>
                    {filterData2
                      ?.filter((x) => x.roleName)
                      .map((x, i) => (
                        <option key={i} value={x.roleName}>
                          {x.roleName}
                        </option>
                      ))}
                  </Form.Select>
                </Form.Group>

                {/* LOCATION */}
                <Form.Group
                  className="filter-item-inline"
                  controlId="locationSelect"
                >
                  <Form.Label className="filter-label">Location:</Form.Label>
                  <Form.Select
                    size="sm"
                    value={filterValues.Location || ""}
                    onChange={(e) =>
                      ApplyFilter("Location", e.target.value || null)
                    }
                  >
                    <option value="">Location</option>
                    {filterData1
                      .filter((x) => x.location)
                      .map((x, i) => (
                        <option key={i} value={x.location}>
                          {x.location}
                        </option>
                      ))}
                  </Form.Select>
                </Form.Group>

                {/* ENGAGEMENT */}
                <Form.Group
                  className="filter-item-inline"
                  controlId="engagementSelect"
                >
                  <Form.Label className="filter-label">Engagement:</Form.Label>
                  <Form.Select
                    size="sm"
                    value={filterValues.Engagementmethod || ""}
                    onChange={(e) =>
                      ApplyFilter("Engagementmethod", e.target.value || null)
                    }
                  >
                    <option value="">Engagement</option>
                    {filterData1
                      .filter((x) => x.engagementmethod)
                      .map((x, i) => (
                        <option key={i} value={x.engagementmethod}>
                          {x.engagementmethod}
                        </option>
                      ))}
                  </Form.Select>
                </Form.Group>

                {/* START TIME */}
                <Form.Group
                  className="filter-item-inline"
                  controlId="dateTimeSelect"
                >
                  <Form.Label className="filter-label">Start Time:</Form.Label>
                  <Form.Select
                    size="sm"
                    value={filterValues.StartTime || ""}
                    onChange={(e) =>
                      ApplyFilter("StartTime", e.target.value || null)
                    }
                  >
                    <option value="">Start Time</option>
                    {filterData1
                      .filter((x) => x.starttime)
                      .sort(
                        (a, b) =>
                          new Date(a.startDateTime) - new Date(b.startDateTime)
                      )
                      .map((x, i) => (
                        <option key={i} value={x.startDateTime}>
                          {x.starttime}
                        </option>
                      ))}
                  </Form.Select>
                </Form.Group>
              </>
            )}
          </div>

          {/* RIGHT: funnel pinned */}
          <div className="filters-right">
            <button
              type="button"
              className="btn btn-light btn-sm filters-nav"
              onClick={toggleFiltersPanel}
              aria-label="Filters"
            >
              <BsFillFunnelFill />
            </button>
          </div>
        </div>

        {showFiltersPanel && (
          <div className="filters-overlay" onClick={closeFiltersPanel}>
            <div
              className="filters-panel"
              onClick={(e) => e.stopPropagation()} // don't close when clicking inside
            >
              <div className="filters-header d-flex justify-content-between align-items-center mb-3">
                <h5 className="m-0">Filters</h5>
                <button
                  type="button"
                  className="btn btn-sm btn-outline-light"
                  onClick={closeFiltersPanel}
                >
                  ✕
                </button>
              </div>

              <div className="event-toolbar">
                {/* TOP: Client / Site / Event */}
                <div className="primary-filters">
                  <SearchableDropdown
                    label="Client"
                    id="dropdown-client"
                    selectedValue={selectedClient}
                    onSelectValue={handleClientChange}
                    options={clientOptions}
                    filteredOptions={filteredClients}
                    searchTerm={clientSearchTerm}
                    setSearchTerm={setClientSearchTerm}
                    placeholder="Select Client"
                  />
                  <SearchableDropdown
                    label="Site"
                    id="dropdown-site"
                    selectedValue={selectedSiteId}
                    onSelectValue={handleSiteChange}
                    options={siteOptions}
                    filteredOptions={filteredSites}
                    searchTerm={siteSearchTerm}
                    setSearchTerm={setSiteSearchTerm}
                    placeholder="Select Site"
                  />
                  <SearchableDropdown
                    label="Event"
                    id="dropdown-event"
                    selectedValue={selectedEvent}
                    onSelectValue={handleEventNameChanges}
                    options={eventOptions}
                    filteredOptions={filteredEvents}
                    searchTerm={eventSearchTerm}
                    setSearchTerm={setEventSearchTerm}
                    placeholder="Select Event"
                  />
                </div>

                <div className="filters-actions">
                  <button
                    className="btn btn-secondary"
                    onClick={handleClearFilters}
                  >
                    Clear
                  </button>
                  <button
                    className="btn btn-primary"
                    disabled={disableApply}
                    onClick={() => {
                      handleApplyFilters();
                      closeFiltersPanel();
                    }}
                  >
                    Apply
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="eventTable" ref={tableRef}>
        <Row>
          <Col>
            <Table>
              <thead className="main-tableheader">
                <tr>
                  <th className="checkbox-col">
                    <Form.Check
                      name="selectAll"
                      className="text-center"
                      checked={
                        StaffData.length > 0 &&
                        selectedRotaShiftIds.length === StaffData.length
                      }
                      onChange={handleSelectAll}
                    />
                  </th>
                  <th
                    style={{ cursor: "pointer", width: "90px" }}
                    onClick={() => requestSort("siteName")}
                  >
                    Site Name {getSortIcon("siteName")}
                  </th>
                  <th
                    style={{ cursor: "pointer", width: "80px" }}
                    onClick={() => requestSort("startTime")}
                  >
                    Start {getSortIcon("startTime")}
                  </th>
                  <th
                    style={{ cursor: "pointer", width: "80px" }}
                    onClick={() => requestSort("finishTime")}
                  >
                    Finish {getSortIcon("finishTime")}
                  </th>
                  <th
                    style={{ cursor: "pointer" }}
                    onClick={() => requestSort("firstName")}
                  >
                    Full Name {getSortIcon("firstName")}
                  </th>
                  <th
                    style={{ cursor: "pointer", width: "70px" }}
                    onClick={() => requestSort("roleName")}
                  >
                    Role {getSortIcon("roleName")}
                  </th>
                  <th
                    style={{ cursor: "pointer" }}
                    onClick={() => requestSort("eventLocation")}
                  >
                    Location {getSortIcon("eventLocation")}
                  </th>
                  <th style={{ width: "50px" }}>
                    <div className="d-flex align-items-center justify-content-center">
                      <span>Actions</span>
                      <Tooltip>
                        <div className="help-item d-flex m-2">
                          <BookOn />
                          <p className="ms-2 mb-0">Book on</p>
                        </div>

                        <div className="help-item d-flex ms-2 my-3">
                          <BookOff />
                          <p className="ms-2 mb-0">Book off</p>
                        </div>

                        <div className="help-item d-flex m-2">
                          <ViewProfile />
                          <p className="ms-2 mb-0">View Profile</p>
                        </div>
                        <div className="help-item d-flex ms-2 my-3">
                          <LogOccur />
                          <p className="ms-2 mb-0">Log an occurrence</p>
                        </div>
                        <div className="help-item d-flex m-2">
                          <ViewOccur />
                          <p className="ms-2 mb-0">View Occurrences</p>
                        </div>
                      </Tooltip>
                    </div>
                  </th>
                </tr>
              </thead>

              <tbody>
                {StaffData.length > 0 ? (
                  sortedStaff.map((person, i) => (
                    <EventControlPersonRow
                      key={person.rotaShiftId ?? i}
                      person={person}
                      selectedRotaShiftIds={selectedRotaShiftIds}
                      handleCheckBox={handleCheckBoxChanges}
                      handleBookOnOff={handleBookOnOff}
                      fetchOccurrencesByRsid={fetchOccurrencesByRsid}
                      handleProfileShiftUpdate={handleProfileShiftUpdate}
                      locationOptions={filterData1
                        .filter((item) => item.location)
                        .map((item) => item.location)
                        .sort()}
                      roleOptions={filterData2
                        .map((item) => ({
                          roleName: item.roleName,
                          roleId: item.roleId
                        }))
                        .sort((a, b) => a.roleName.localeCompare(b.roleName))}
                      jwt={jwt}
                      setStaffData={setStaffData}
                    />
                  ))
                ) : (
                  <tr>
                    <td colSpan={8} className="text-center">
                      <div className="custom-message">
                        <div className="d-flex align-items-center justify-content-center">
                          <div>
                            <BsLaptop className="custom-icon" />
                            <VscGraph className="custom-icon mx-3" />
                            <RiUserSearchFill className="custom-icon" />
                          </div>
                        </div>

                        <h3>
                          <strong>Start your search!</strong>
                        </h3>
                        <p>
                          Select the filters above and click apply to get
                          started.
                        </p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </Col>
        </Row>
      </div>
      <div className="d-flex justify-content-between align-items-center mt-3 mb-4">
        <div className="results-amount">
          <p className="text-white">{getShowingText(totalItems)}</p>
        </div>
        <div /> {/* keep layout spacing, empty right side */}
      </div>

      <BulkEdit
        locationOptions={filterData1
          .filter((item) => item.location)
          .map((item) => item.location)
          .sort()}
      />
      <Modal
        show={showConflictModal}
        onHide={() => setShowConflictModal(false)}
        size="lg"
        centered
        dialogClassName="conflict-modal"
      >
        <Modal.Header closeButton closeVariant="white">
          <Modal.Title>
            {conflictAction === "off" &&
              "Some selected staff are already booked off"}
            {conflictAction === "on" &&
              "Some selected staff are already booked on"}
            {conflictAction === "notOn" &&
              "Some selected staff are not booked on yet"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="d-block">
          <p className="mb-3 text-white d-inline">
            {conflictAction === "off" && "These staff are already booked off."}
            {conflictAction === "on" && "These staff are already booked on."}
            {conflictAction === "notOn" &&
              "These staff are not currently booked on, but you are trying to book them off."}{" "}
            Tick the ones you want to remove from the bulk action, or use{" "}
            <strong>“Remove all”</strong>. Then click{" "}
            <strong>
              Remove selected and continue Book{" "}
              {conflictOnOffStatus === 0 ? "Off" : "On"}
            </strong>{" "}
            to proceed with the rest.
          </p>

          <div className="d-flex justify-content-between align-items-center mb-3">
            <Form.Check
              type="checkbox"
              label="Remove all"
              checked={
                conflictStaff.length > 0 &&
                conflictRemoveIds.length === conflictStaff.length
              }
              onChange={(e) =>
                e.target.checked
                  ? selectAllConflictsForRemoval()
                  : clearAllConflictsForRemoval()
              }
            />
            <small className="text-muted">
              {conflictRemoveIds.length} of {conflictStaff.length} marked for
              removal
            </small>
          </div>

          <div className="table-responsive conflict-table-wrapper">
            <Table striped bordered hover size="sm" className="mb-0">
              <thead>
                <tr>
                  <th style={{ width: "60px" }}>Remove</th>
                  <th>First name</th>
                  <th>Last name</th>
                  <th>Role</th>
                  <th>Location</th>
                  <th>
                    {conflictAction === "off" ? "Booked off" : "Booked on"}
                  </th>
                </tr>
              </thead>
              <tbody>
                {conflictStaff.map((s) => (
                  <tr key={s.rotaShiftId}>
                    <td className="text-center">
                      <Form.Check
                        type="checkbox"
                        checked={conflictRemoveIds.includes(s.rotaShiftId)}
                        onChange={() => toggleConflictRemove(s.rotaShiftId)}
                      />
                    </td>
                    <td>{s.firstName}</td>
                    <td>{s.lastName}</td>
                    <td>{s.roleName}</td>
                    <td>{s.eventLocation}</td>
                    <td>
                      {conflictAction === "off"
                        ? s.bookedOffDateTime
                        : s.bookedOnDateTime}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowConflictModal(false)}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleResolveConflictsAndContinue}
            disabled={conflictRemoveIds.length === 0}
          >
            Remove selected and continue Book{" "}
            {conflictOnOffStatus === 0 ? "Off" : "On"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default EventControlTable;
